import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  isMarketplaceAuction,
  isMarketplaceDraw,
} from '~admin/view/components/details/helper/marketplace.helper';
import { DatetimeField } from '~admin/view/components/ui/form/fields/field-datetime.component';
import { MarketplaceType } from '~client/model/marketplace-type';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';

interface Props {
  name: string;
  type: MarketplaceType;
}

export interface AllocationTimeDetailsFormData {
  timeToForceAllYoopAllocation?: string;
  timeToStartPickingSeats?: string;
  timeToForAllSeatAllocation?: string;
}

export const AllocationTimeDetails: React.FunctionComponent<Props> = ({ name, type }) => {
  const { t } = useTranslation();

  return (
    <Container>
      {isMarketplaceDraw(type) && (
        <Row>
          <RestrictBox>
            <DatetimeField
              name={`${name}.timeToForceAllYoopAllocation`}
              label={t('createEvent.marketplaceDetails.dateTime.timeToForceAllYoopAllocation')}
            />
          </RestrictBox>
        </Row>
      )}
      {isMarketplaceAuction(type) && (
        <Row>
          <RestrictBox>
            <DatetimeField
              name={`${name}.timeToStartPickingSeats`}
              label={t('createEvent.marketplaceDetails.dateTime.timeToStartPickingSeats')}
            />
          </RestrictBox>
          <RestrictBox>
            <DatetimeField
              name={`${name}.timeToForAllSeatAllocation`}
              label={t('createEvent.marketplaceDetails.dateTime.timeToForAllSeatAllocation')}
            />
          </RestrictBox>
        </Row>
      )}
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;

  > div:not(:first-child) {
    margin-top: 16px;
  }
`;

const Row = styled(Box)`
  margin-top: 12px;

  > div:not(:first-child) {
    margin-left: 50px;
  }
`;

const RestrictBox = styled(Box)`
  flex: 1 1 auto;
  margin: 0 12px;
`;



// WEBPACK FOOTER //
// ./view/components/details/marketplace-details/marketplace-datetime-details/allocation-time-details.component.tsx